import { debounce } from 'lodash-es'

import { MAX_USING_FEE, MIN_USING_FEE } from '@/entities/map'
import { useMultiScrollState } from '@/shared/lib'
import { Slider } from '@/shared/ui'

import { Filter, useFilter } from '../../model/filter'

const options = [
  0, 50000, 100000, 150000, 200000, 250000, 300000, 350000, 400000, 500000,
  600000, 700000, 800000, 900000, 1000000,
]

const formatUsingFee = (fee: number) => {
  if (fee === MAX_USING_FEE) {
    return `${fee / 10000}만 원+`
  }

  return `${fee / 10000}만 원`
}

export const UsingFee = () => {
  const { registerScrollElement } = useMultiScrollState<HTMLDivElement>()

  const {
    filter: { minUsingFee, maxUsingFee },
    updateFilter,
  } = useFilter()

  const minUsingFeeValue = minUsingFee ?? MIN_USING_FEE
  const maxUsingFeeValue = maxUsingFee ?? MAX_USING_FEE

  const handleUsingFeeChange = debounce(([min, max]: number[]) => {
    updateFilter({
      minUsingFee: min === MIN_USING_FEE ? null : min,
      maxUsingFee: max === MAX_USING_FEE ? null : max,
    })
  }, 500)

  return (
    <div
      className="p-6 pt-0 pr-4"
      ref={element => {
        if (element) {
          registerScrollElement(Filter.UsingFee, element)
        }
      }}
    >
      <div className="mb-3 flex items-center justify-between">
        <div className="flex flex-col">
          <h3 className="typo-body1 font-semibold text-black">가격</h3>
          <p className="typo-label2 font-normal text-gray-500">
            1주 임대료 및 관리비
          </p>
        </div>
        <p className="typo-label1 font-medium text-purple-500">
          {minUsingFeeValue !== MIN_USING_FEE &&
            formatUsingFee(minUsingFeeValue)}{' '}
          ~ {formatUsingFee(maxUsingFeeValue)}
        </p>
      </div>
      <Slider
        name="usingFee"
        value={[minUsingFeeValue, maxUsingFeeValue]}
        onValueChange={handleUsingFeeChange}
        minStepsBetweenThumbs={1}
        format={formatUsingFee}
        options={options}
        showRange
      />
    </div>
  )
}
